module.exports = __webpack_public_path__ + "static/img/JO@2x.b1e535a9.jpg";